<!-- Route info modal -->
<div class="modal fade route-modal" id="info" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content" dir="rtl">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-list-alt"></i> جزئیات نقاط مسیر
        </h5>
        <div class="d-flex align-items-center gap-2">
          <button
            type="button"
            class="modal-reload"
            (click)="reloadRequested.emit()"
            title="به‌روزرسانی"
          >
            <i class="fa fa-refresh"></i>
          </button>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
      </div>
      <div class="modal-body">
        <div class="count-pill" *ngIf="routeData">
          <i class="fa fa-map-pin"></i> تعداد نقاط
          <b>{{ routeData.length | faNum }}</b>
        </div>
        <div class="route-table-wrap table-responsive">
          <table
            class="table table-striped table-hover align-middle mb-0"
            id="excel-info"
          >
            <thead>
              <tr class="text-center">
                <th>ردیف</th>
                <th>تاریخ</th>
                <th class="pointer" (click)="toggleSortByTime()">
                  <i class="fa fa-sort-amount-asc"></i>&nbsp;ساعت
                </th>
                <th>سرعت</th>
                <th>زاویه</th>
                <th>فاصله</th>
                <th>ولتاژ دینام (ولت)</th>
                <th>وضعیت</th>
                <th>طول جغرافیایی</th>
                <th>عرض جغرافیایی</th>
                <th>موقعیت</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" *ngFor="let item of routeData?.slice().reverse(); let i = index">
                <td class="fw-bold">{{ i + 1 | faNum }}</td>
                <td>{{ item.strDate | faNum }}</td>
                <td class="fw-bold">{{ item.strTime | faNum }}</td>
                <td>{{ item.iSpeed | faNum }}</td>
                <td>{{ item.iAngle | faNum }}</td>
                <td>{{ item.fDistance | faNum }}</td>
                <td>{{ item.fPower | faNum }}</td>
                <td>
                  <span [ngClass]="item.bOnOff ? 'status-on' : 'status-off'">{{
                    item.bOnOff ? "روشن" : "خاموش"
                  }}</span>
                </td>
                <td dir="ltr" class="text-muted">{{ item.fLon }}</td>
                <td dir="ltr" class="text-muted">{{ item.fLat }}</td>
                <td>{{ item.strPosName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn-excel"
          (click)="exportExcel('excel-info')"
        >
          <i class="fa fa-file-excel-o"></i> خروجی اکسل
        </button>
        <button
          type="button"
          class="btn-calc"
          *ngIf="canRecalculate"
          (click)="recalculateRequested.emit()"
        >
          <i class="fa fa-calculator"></i> محاسبه فاصله‌ها
        </button>
      </div>
    </div>
  </div>
</div>
